import { SVGProps } from 'react';
import GoogleLogoSvg from './google-logo.svg?react';

export const GoogleLogo = (props: SVGProps<SVGSVGElement>) => {
  return <GoogleLogoSvg {...props} />;
};
